import classNames from 'classnames';
import React, { useContext, useRef } from 'react';

import styles from './App.module.scss';
import LowerBar from './components/LowerBar';
import MiddleBar from './components/MiddleBar';
import MobileSearchBar from './components/SearchBar/MobileSearchBar';
import TopBar from './components/TopBar';
import AppContext from './context';
import { BURGER_PANEL_PORTAL, THEME_CLASSNAME_MAP } from './utils/constants';
import { getWebFonts } from './utils/fontUtils';
import { SentryBoundary } from './utils/SentryBoundary';
import { useHeaderVersion } from './utils/useHeaderVersion';

import './theme/variables.scss';

function Header(): React.JSX.Element | null {
    const { showCategories, isError, showSearch, bundle } =
        useContext(AppContext);

    useHeaderVersion();

    const headerRef = useRef<HTMLElement>(null);

    if (isError) return null;

    const themeClass = THEME_CLASSNAME_MAP[bundle];
    const fonts = getWebFonts(bundle === 'bitiba');

    return (
        <SentryBoundary componentId="header">
            <div
                className={classNames(styles.wrapper, themeClass)}
                data-zta="shop-header">
                <style data-zta="shop-header-fonts">{fonts}</style>
                <header
                    className={styles.header}
                    data-zta="shop-header-component"
                    id="shop-header"
                    ref={headerRef}>
                    <div className={classNames(styles.topBarWrapper)}>
                        <TopBar />
                    </div>
                    <div className={classNames(styles.middleBarWrapper)}>
                        <MiddleBar />
                    </div>
                    <div id={BURGER_PANEL_PORTAL} />
                    {showCategories && (
                        <div className={classNames(styles.lowerBarWrapper)}>
                            <LowerBar />
                        </div>
                    )}
                </header>
                {showSearch && <MobileSearchBar />}
            </div>
        </SentryBoundary>
    );
}

export default Header;
